export const notificationConstants = {
  GET_ADMIN_NOTIFICATION_REQUEST: "GET_ADMIN_NOTIFICATION_REQUEST",
  GET_ADMIN_NOTIFICATION_SUCCESS: "GET_ADMIN_NOTIFICATION_SUCCESS",
  GET_ADMIN_NOTIFICATION_FAILURE: "GET_ADMIN_NOTIFICATION_FAILURE",
};
